import React from 'react';
import * as XLSX from 'xlsx';
import Spreadsheet from "x-data-spreadsheet";
import '../asset/css/xspreadsheet.css';

/*! xlsxspread.js (C) SheetJS LLC -- https://sheetjs.com/ */
/* eslint-env browser */
/*global XLSX */
/*exported stox, xtos */

/**
 * Converts data from SheetJS to x-spreadsheet
 *
 * @param  {Object} wb SheetJS workbook object
 *
 * @returns {Object[]} An x-spreadsheet data
 */
function stox(wb) {
    var out = [];
    wb.SheetNames.forEach(function (name) {
      var o = { name: name, rows: {} };
      var ws = wb.Sheets[name];
      if(!ws || !ws["!ref"]) return;
      var range = XLSX.utils.decode_range(ws['!ref']);
      // sheet_to_json will lost empty row and col at begin as default
      range.s = { r: 0, c: 0 };
      var aoa = XLSX.utils.sheet_to_json(ws, {
        raw: false,
        header: 1,
        range: range
      });
  
      aoa.forEach(function (r, i) {
        var cells = {};
        r.forEach(function (c, j) {
          cells[j] = { text: c || String(c) };
  
          var cellRef = XLSX.utils.encode_cell({ r: i, c: j });
  
          if ( ws[cellRef] != null && ws[cellRef].f != null) {
            cells[j].text = "=" + ws[cellRef].f;
          }
        });
        o.rows[i] = { cells: cells };
      });
      o.rows.len = aoa.length;
  
      o.merges = [];
      (ws["!merges"]||[]).forEach(function (merge, i) {
        //Needed to support merged cells with empty content
        if (o.rows[merge.s.r] == null) {
          o.rows[merge.s.r] = { cells: {} };
        }
        if (o.rows[merge.s.r].cells[merge.s.c] == null) {
          o.rows[merge.s.r].cells[merge.s.c] = {};
        }
  
        o.rows[merge.s.r].cells[merge.s.c].merge = [
          merge.e.r - merge.s.r,
          merge.e.c - merge.s.c
        ];
  
        o.merges[i] = XLSX.utils.encode_range(merge);
      });
  
      out.push(o);
    });
  
    return out;
}

function HtmlTableViewer({ arrayBuffer }) {
    const ref = React.useRef();

    React.useEffect(() => {
        async function showSheet() {
            const wb = XLSX.read(arrayBuffer);
            new Spreadsheet(ref.current, {mode: 'read', showToolbar: false, view: {
                height: () => 500,
                width: () => document.getElementById("spreadsheet").offsetWidth,
            }}).loadData(stox(wb));
        }
    
        showSheet();
    }, [arrayBuffer]);

    return <div id='spreadsheet' ref={ref}/>;
}

export default HtmlTableViewer;
